/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'sites',
        title: 'Sites',
        type: 'basic',
        icon: 'heroicons_outline:building-storefront',
        link: '/sites',
        roles: ['superadmin'],
        appModels: ['ecommerce'],
    },
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
        roles: ['superadmin'],
        appModels: ['ecommerce'],
    },
    {
        id: 'homedash',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/homedash',
    },
    {
        id: 'drmed-appointments',
        title: 'Agendamentos',
        meta: 'Geranciamento de Agenda',
        icon: 'heroicons_outline:calendar',
        type: 'basic',
        link: '/drmed/appointments',
        appModels: ['drmed'],
    },
    {
        id: 'cadastros-drmed',
        title: 'Cadastros',
        type: 'group',
        appModels: ['drmed'],
        children: [
            {
                id: 'drmed-patients',
                title: 'Pacientes',
                meta: 'Geranciamento de Pacientes',
                icon: 'heroicons_outline:users',
                type: 'basic',
                link: '/drmed/patients',
                appModels: ['drmed'],
            },
            {
                id: 'drmed-doctors',
                title: 'Médicos',
                meta: 'Geranciamento de Médicos',
                icon: 'heroicons_outline:users',
                type: 'basic',
                link: '/drmed/doctors',
                appModels: ['drmed'],
            },
        ]
    },
    {
        id: 'tools-drmed',
        title: 'Ferramentas',
        type: 'group',
        appModels: ['drmed'],
    },
    {
        id: 'drmed',
        title: 'MedScan',
        meta: 'Geranciamento de Clínica Médica',
        type: 'collapsable',
        // uncollapse: true,
        icon: 'heroicons_outline:academic-cap',
        link: '/drmed/medscan',
        appModels: ['drmed'],
        children: [
            {
                id: 'drmed-medscan',
                title: 'Scanner',
                type: 'basic',
                link: '/drmed/medscan',
            },
        ]
    },
    {
        id: 'pedidos',
        title: 'Pedidos',
        type: 'basic',
        icon: 'heroicons_outline:shopping-bag',
        link: '/pedidos',
        extra: '/tempcart',
        featureExtra: 'store_cart_management',
        appModels: ['ecommerce'],
    },
    {
        id: 'reports',
        title: 'Reports',
        type: 'basic',
        icon: 'heroicons_outline:chart-bar',
        link: '/reports',
        feature: 'reports',
        appModels: ['ecommerce'],
    },
    {
        id: 'fidelidade',
        title: 'Fidelidade',
        type: 'basic',
        icon: 'mat_outline:loyalty',
        link: '/fidelidade',
        feature: 'loyalty_program',
        appModels: ['ecommerce'],
    },
    {
        id: 'cadastros',
        title: 'Cadastros',
        type: 'group',
        appModels: ['ecommerce'],
    },
    {
        id: 'produtos',
        title: 'Produtos',
        type: 'basic',
        icon: 'heroicons_outline:cube',
        link: '/produtos',
        extra: '/produtos/criar',
        appModels: ['ecommerce'],
    },
    {
        id: 'categorias',
        title: 'Categorias',
        type: 'basic',
        icon: 'mat_solid:category',
        link: '/categorias',
        extra: '/categorias/criar',
        appModels: ['ecommerce'],
    },
    {
        id: 'marcas',
        title: 'Marcas',
        type: 'basic',
        icon: 'heroicons_outline:squares-2x2',
        link: '/marcas',
        extra: '/marcas/criar',
        appModels: ['ecommerce'],
    },
    {
        id: 'grupos',
        title: 'Grupos',
        type: 'basic',
        icon: 'heroicons_outline:table-cells',
        link: '/grupos',
        roles: ['superadmin'],
        extra: '/grupos/criar',
        appModels: ['ecommerce'],
    },
    {
        id: 'coupons',
        title: 'Coupons',
        type: 'basic',
        icon: 'heroicons_outline:tag',
        link: '/coupons',
        extra: '/coupons/criar',
        appModels: ['ecommerce'],
    },
    {
        id: 'faq',
        title: 'F.A.Q.',
        type: 'basic',
        icon: 'heroicons_outline:question-mark-circle',
        link: '/faq',
        extra: '/faq/criar',
        appModels: ['ecommerce'],
    },
    {
        id: 'banners',
        title: 'Banners',
        type: 'basic',
        icon: 'heroicons_outline:window',
        link: '/banners',
        extra: '/banners/criar',
        appModels: ['ecommerce'],
    },
    {
        id: 'clientes',
        title: 'Clientes',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/clientes',
        appModels: ['ecommerce'],
    },
    {
        id: 'uploads',
        title: 'Uploads',
        type: 'basic',
        icon: 'heroicons_outline:document',
        link: '/uploads',
        feature: 'store_uploads',
        appModels: ['ecommerce'],
    },
    {
        id: 'medias',
        title: 'Medias',
        type: 'basic',
        icon: 'heroicons_outline:document',
        link: '/medias',
        // feature: 'store_medias',
    },
    {
        id: 'spacer-group',
        type: 'group',
    },
    {
        id: 'facebook',
        title: 'Facebook',
        type: 'sidemenu',
        icon: 'heroicons_outline:hand-thumb-up',
        roles: ['owner'],
        feature: 'facebook_pages',
        children: [
            {
                id: 'facebook.fbpages',
                title: 'Page Feed',
                type: 'basic',
                icon: 'heroicons_outline:hand-thumb-up',
                link: '/fb-pages'
            },
        ],
        appModels: ['ecommerce'],
    },
    {
        id: 'configuracoes',
        title: 'Configurações',
        type: 'sidemenu',
        icon: 'heroicons_outline:cog',
        roles: ['admin', 'owner'],
        children: [
            {
                id: 'startconfig',
                title: 'Configuração da Loja',
                type: 'basic',
                icon: 'heroicons_outline:cog-6-tooth',
                link: '/configuresualoja',
                feature: 'store_settings2',
                appModels: ['ecommerce'],
            },
            {
                id: 'configuracoes.storesettings',
                title: 'Ajustes',
                type: 'basic',
                icon: 'heroicons_outline:wrench-screwdriver',
                link: '/settings/store',
                appModels: ['ecommerce'],
            },
            {
                id: 'configuracoes.usuarios',
                title: 'Usuários',
                type: 'basic',
                icon: 'heroicons_outline:identification',
                link: '/settings/users',
                roles: ['owner'],
            },
            {
                id: 'configuracoes.auditlogs',
                title: 'Audit Logs',
                type: 'basic',
                icon: 'heroicons_outline:rectangle-stack',
                link: '/settings/auditlogs',
            },
            {
                id: 'configuracoes.subscription',
                title: 'Assinatura',
                type: 'basic',
                icon: 'heroicons_outline:sparkles',
                link: '/tenant/paywall',
                roles: ['admin', 'owner'],
            },
        ],
    },
];
export const noTenantNavigation: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'Home',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/home',
    },
    {
        id      : 'apps',
        title   : 'Aplicativos',
        subtitle: 'Aplicativos para seu negócio',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [
            {
                id: 'sites',
                title: 'E-commerce',
                type: 'basic',
                icon: 'heroicons_outline:building-storefront',
                link: '/sites',
            },
            {
                id: 'clinicas',
                title: 'Clínicas',
                type: 'basic',
                icon: 'heroicons_outline:building-office',
                link: '/sites',
                userFeature: 'dr_med_app',
            },
            {
                id: 'instagram',
                title: 'Instagram Business',
                meta: 'Geranciamento de Instagram',
                type: 'collapsable',
                icon: 'heroicons_outline:camera',
                // feature: 'store_settings2',
                link: '/instagram/profile',
                children: [
                    {
                        id: 'insta-profile',
                        title: 'Perfil',
                        type: 'basic',
                        link: '/instagram/profile',
                    },

                    {
                        id: 'insta-media',
                        title: 'Publicações',
                        type: 'basic',
                        link: '/instagram/media',
                    },
                    {
                        id: 'insta-create-post',
                        title: 'Criar Post',
                        type: 'basic',
                        link: '/instagram/create',
                    },
                    {
                        id: 'insta-conversations',
                        title: 'Caixa de Entrada',
                        type: 'basic',
                        link: '/instagram/inbox',
                    },
                ]
            },
            {
                id: 'ai-media-gallery',
                title: 'Galeria de Imagens',
                type: 'basic',
                icon: 'heroicons_outline:photo',
                link: '/ai-media-gallery',
            },
            {
                id: 'media-editor',
                title: 'Editor de Imagens',
                type: 'basic',
                icon: 'heroicons_outline:scissors',
                link: '/media-editor',
                roles: ['superadmin'],
            },
            {
                id: 'page-builder',
                title: 'Page Builder',
                type: 'basic',
                icon: 'heroicons_outline:document',
                link: '/page-builder',
                userFeature: 'page_builder',
            }
        ],
    },
    {
        id      : 'confs',
        title   : 'Configurações',
        subtitle: 'Configurações do sistema',
        type    : 'group',
        icon    : 'heroicons_outline:home',
    },
    {
        id: 'paywall',
        title: 'Meu Plano',
        meta: 'Gerencie seu plano e créditos',
        type: 'basic',
        icon: 'heroicons_outline:sparkles',
        link: '/paywall',
    },
    {
        id: 'myaccount',
        title: 'Minha Conta',
        meta: 'Configure sua conta',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/minhaconta'
    },
    {
        id: 'connectfb',
        title: 'Facebook Business',
        meta: 'Conecte sua conta ao Facebook',
        type: 'basic',
        icon: 'heroicons_outline:hand-thumb-up',
        link: '/fbintegration',
        userFeature: 'fb_integration',
    },
    {
        id: 'superadmin-tools',
        title: 'Superadmin',
        subtitle: 'Operação interna',
        type: 'group',
        icon: 'heroicons_outline:wrench-screwdriver',
        roles: ['superadmin'],
        children: [
            {
                id: 'subscriptions',
                title: 'Assinaturas',
                meta: 'Billing e renovação',
                type: 'basic',
                icon: 'heroicons_outline:credit-card',
                link: '/dex-subscriptions',
                roles: ['superadmin'],
            },
            {
                id: 'users',
                title: 'Dex Users',
                meta: 'Users na Dex',
                type: 'basic',
                icon: 'heroicons_outline:users',
                link: '/dex-users',
                roles: ['superadmin'],
            },
        ],
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
